import { getLocalTimeZone } from '@internationalized/date';
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function interweaveArrays<T, U>(arr1: T[], arr2: U[]) {
    const result = [];
    const maxLength = Math.max(arr1.length, arr2.length);

    for (let i = 0; i < maxLength; i++) {
        if (i < arr1.length) {
            result.push(arr1[i]);
        }
        if (i < arr2.length) {
            result.push(arr2[i]);
        }
    }

    return result;
}

export function toLocalTime(dateStr: string, options: Intl.DateTimeFormatOptions) {
    // Force UTC interpretation by appending 'Z' if not already in UTC format
    const utcDate = new Date(dateStr + 'Z');

    const berlinTime = new Intl.DateTimeFormat('de-DE', {
        ...options,
        timeZone: getLocalTimeZone()
    }).format(utcDate);

    return berlinTime;
};
